/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminSemesterDetailDTO,
  AdminSemesterGetAdminSemestersForOrganizationParams,
  AdminSemesterListItemDTOQueryResultDTO,
  UpsertAdminSemesterDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminSemesterGetAdminSemesterDetail = (
    organizationId: number,
    semesterId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminSemesterDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminSemester/${semesterId}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminSemesterGetAdminSemesterDetailQueryKey = (organizationId: number,
    semesterId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminSemester/${semesterId}`] as const;
    }

    
export const getAdminSemesterGetAdminSemesterDetailQueryOptions = <TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError = ErrorType<unknown>>(organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSemesterGetAdminSemesterDetailQueryKey(organizationId,semesterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>> = ({ signal }) => adminSemesterGetAdminSemesterDetail(organizationId,semesterId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && semesterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSemesterGetAdminSemesterDetailQueryResult = NonNullable<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>>
export type AdminSemesterGetAdminSemesterDetailQueryError = ErrorType<unknown>


export function useAdminSemesterGetAdminSemesterDetail<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>,
          TError,
          Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSemesterGetAdminSemesterDetail<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>,
          TError,
          Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSemesterGetAdminSemesterDetail<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSemesterGetAdminSemesterDetail<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemesterDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSemesterGetAdminSemesterDetailQueryOptions(organizationId,semesterId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminSemesterUpdateSemesterForOrganization = (
    organizationId: number,
    semesterId: number,
    upsertAdminSemesterDTO: UpsertAdminSemesterDTO,
 ) => {
      
      
      return customInstance<AdminSemesterDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminSemester/${semesterId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminSemesterDTO
    },
      );
    }
  


export const getAdminSemesterUpdateSemesterForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSemesterUpdateSemesterForOrganization>>, TError,{organizationId: number;semesterId: number;data: UpsertAdminSemesterDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminSemesterUpdateSemesterForOrganization>>, TError,{organizationId: number;semesterId: number;data: UpsertAdminSemesterDTO}, TContext> => {
    
const mutationKey = ['adminSemesterUpdateSemesterForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSemesterUpdateSemesterForOrganization>>, {organizationId: number;semesterId: number;data: UpsertAdminSemesterDTO}> = (props) => {
          const {organizationId,semesterId,data} = props ?? {};

          return  adminSemesterUpdateSemesterForOrganization(organizationId,semesterId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSemesterUpdateSemesterForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminSemesterUpdateSemesterForOrganization>>>
    export type AdminSemesterUpdateSemesterForOrganizationMutationBody = UpsertAdminSemesterDTO
    export type AdminSemesterUpdateSemesterForOrganizationMutationError = ErrorType<unknown>

    export const useAdminSemesterUpdateSemesterForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSemesterUpdateSemesterForOrganization>>, TError,{organizationId: number;semesterId: number;data: UpsertAdminSemesterDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSemesterUpdateSemesterForOrganization>>,
        TError,
        {organizationId: number;semesterId: number;data: UpsertAdminSemesterDTO},
        TContext
      > => {

      const mutationOptions = getAdminSemesterUpdateSemesterForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminSemesterDeleteSemester = (
    organizationId: number,
    semesterId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminSemester/${semesterId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminSemesterDeleteSemesterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSemesterDeleteSemester>>, TError,{organizationId: number;semesterId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminSemesterDeleteSemester>>, TError,{organizationId: number;semesterId: number}, TContext> => {
    
const mutationKey = ['adminSemesterDeleteSemester'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSemesterDeleteSemester>>, {organizationId: number;semesterId: number}> = (props) => {
          const {organizationId,semesterId} = props ?? {};

          return  adminSemesterDeleteSemester(organizationId,semesterId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSemesterDeleteSemesterMutationResult = NonNullable<Awaited<ReturnType<typeof adminSemesterDeleteSemester>>>
    
    export type AdminSemesterDeleteSemesterMutationError = ErrorType<unknown>

    export const useAdminSemesterDeleteSemester = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSemesterDeleteSemester>>, TError,{organizationId: number;semesterId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSemesterDeleteSemester>>,
        TError,
        {organizationId: number;semesterId: number},
        TContext
      > => {

      const mutationOptions = getAdminSemesterDeleteSemesterMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminSemesterGetAdminSemestersForOrganization = (
    organizationId: number,
    params?: AdminSemesterGetAdminSemestersForOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminSemesterListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminSemester`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminSemesterGetAdminSemestersForOrganizationQueryKey = (organizationId: number,
    params?: AdminSemesterGetAdminSemestersForOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminSemester`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminSemesterGetAdminSemestersForOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminSemesterGetAdminSemestersForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSemesterGetAdminSemestersForOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>> = ({ signal }) => adminSemesterGetAdminSemestersForOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSemesterGetAdminSemestersForOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>>
export type AdminSemesterGetAdminSemestersForOrganizationQueryError = ErrorType<unknown>


export function useAdminSemesterGetAdminSemestersForOrganization<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminSemesterGetAdminSemestersForOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSemesterGetAdminSemestersForOrganization<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminSemesterGetAdminSemestersForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSemesterGetAdminSemestersForOrganization<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminSemesterGetAdminSemestersForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSemesterGetAdminSemestersForOrganization<TData = Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminSemesterGetAdminSemestersForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSemesterGetAdminSemestersForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSemesterGetAdminSemestersForOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminSemesterCreateSemesterForOrganization = (
    organizationId: number,
    upsertAdminSemesterDTO: UpsertAdminSemesterDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminSemesterDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminSemester`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminSemesterDTO, signal
    },
      );
    }
  


export const getAdminSemesterCreateSemesterForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSemesterCreateSemesterForOrganization>>, TError,{organizationId: number;data: UpsertAdminSemesterDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminSemesterCreateSemesterForOrganization>>, TError,{organizationId: number;data: UpsertAdminSemesterDTO}, TContext> => {
    
const mutationKey = ['adminSemesterCreateSemesterForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSemesterCreateSemesterForOrganization>>, {organizationId: number;data: UpsertAdminSemesterDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminSemesterCreateSemesterForOrganization(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSemesterCreateSemesterForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminSemesterCreateSemesterForOrganization>>>
    export type AdminSemesterCreateSemesterForOrganizationMutationBody = UpsertAdminSemesterDTO
    export type AdminSemesterCreateSemesterForOrganizationMutationError = ErrorType<unknown>

    export const useAdminSemesterCreateSemesterForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSemesterCreateSemesterForOrganization>>, TError,{organizationId: number;data: UpsertAdminSemesterDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSemesterCreateSemesterForOrganization>>,
        TError,
        {organizationId: number;data: UpsertAdminSemesterDTO},
        TContext
      > => {

      const mutationOptions = getAdminSemesterCreateSemesterForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    